import { render } from "./Widget5.vue?vue&type=template&id=5b1764e1"
import script from "./Widget5.vue?vue&type=script&lang=js"
export * from "./Widget5.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vistream-spa-cp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__